import { useState, useEffect } from "react";
import { fetchCityPairs } from "../api/contentfulService";

const FALLBACK_STATIONS = {
  YXX: "Abbotsford",
  YYC: "Calgary",
  YYG: "Charlottetown",
  YEG: "Edmonton",
  YHZ: "Halifax",
  YKF: "Kitchener-Waterloo",
  YVR: "Vancouver",
  YLW: "Kelowna",
  YWG: "Winnipeg",
  YSJ: "Saint John",
  YQT: "Thunder Bay",
  YYJ: "Victoria",
  YYZ: "Toronto",
  YUL: "Montreal",
  YQM: "Moncton",
  FLL: "Fort Lauderdale",
  LAS: "Las Vegas",
  LAX: "Los Angeles",
  MCO: "Orlando",
  SFO: "San Francisco",
  CUN: "Cancun",
  GDL: "Guadalajara",
  KIN: "Kingston",
  PUJ: "Punta Cana",
  PVR: "Puerto Vallarta",
  MBJ: "Montego Bay",
  MEX: "Mexico City",
};

let cache = null;

export const useStations = () => {
  const [stations, setStations] = useState(cache?.stations || FALLBACK_STATIONS);
  const [cityPairs, setCityPairs] = useState(cache?.cityPairs || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) return;

    fetchCityPairs()
      .then((pairs) => {
        const stationMap = {};
        pairs.forEach((pair) => {
          if (pair.departureStation) {
            stationMap[pair.departureStation.code] = pair.departureStation.name;
          }
          if (pair.arrivalStation) {
            stationMap[pair.arrivalStation.code] = pair.arrivalStation.name;
          }
        });

        console.log(`[useStations] ✅ Loaded ${Object.keys(stationMap).length} stations from Contentful`);
        cache = { stations: stationMap, cityPairs: pairs };
        setStations(stationMap);
        setCityPairs(pairs);
      })
      .catch((err) => {
        console.warn("[useStations] ⚠️ Failed to fetch from Contentful, using fallback", err);
        cache = { stations: FALLBACK_STATIONS, cityPairs: [] };
      })
      .finally(() => setLoading(false));
  }, []);

  const getDestinationsForOrigin = (originCode) => {
    if (!cityPairs.length) return stations;
    const destinations = {};
    cityPairs.forEach((pair) => {
      if (pair.departureStation?.code === originCode && pair.arrivalStation) {
        destinations[pair.arrivalStation.code] = pair.arrivalStation.name;
      }
    });
    return Object.keys(destinations).length ? destinations : stations;
  };

  const getOriginsForDestination = (destCode) => {
    if (!cityPairs.length) return stations;
    const origins = {};
    cityPairs.forEach((pair) => {
      if (pair.arrivalStation?.code === destCode && pair.departureStation) {
        origins[pair.departureStation.code] = pair.departureStation.name;
      }
    });
    return Object.keys(origins).length ? origins : stations;
  };

  return { stations, loading, getDestinationsForOrigin, getOriginsForDestination };
};
